module.exports = __webpack_public_path__ + "static/img/fluid-image-1.be934788.jpg";